"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletResponseSchema = exports.WalletChainSchema = exports.WalletAssetSchema = exports.AtomicAmountSchema = void 0;
const zod_1 = require("zod");
const auth_1 = require("./auth");
exports.AtomicAmountSchema = zod_1.z.string().regex(/^\d+$/);
exports.WalletAssetSchema = zod_1.z.object({
    code: zod_1.z.string(),
    symbol: zod_1.z.string(),
    decimals: zod_1.z.number().int().min(0),
    confirmed: exports.AtomicAmountSchema,
    pending: exports.AtomicAmountSchema,
    /** Confirmed minus the amounts of this user's withdrawals that have not yet been broadcast. */
    available: exports.AtomicAmountSchema,
    /** False when the asset is not withdrawable for this user (catalogue flag or per-user override). */
    withdrawEnabled: zod_1.z.boolean(),
});
exports.WalletChainSchema = zod_1.z.object({
    code: zod_1.z.string(),
    name: zod_1.z.string(),
    /** The chain family, for clients that need to pick address-validation or UI logic without
     * guessing from `code`: today `evm` covers Ethereum, `tron` covers Tron. */
    type: zod_1.z.enum(['evm', 'tron']),
    nativeSymbol: zod_1.z.string(),
    master: zod_1.z.object({ address: zod_1.z.string(), explorerUrl: zod_1.z.url() }).nullable(),
    /** Always `true` since 2026-10-27 (ADR 0009: balances come from CCex snapshots, there is no live read to fail). Kept so Mini App bundles cached before that release keep rendering; drop in a later release. */
    balancesAvailable: zod_1.z.boolean(),
    /** Monthly withdrawal count quota for this chain, for the current UTC month. */
    withdrawal: zod_1.z.object({
        enabled: zod_1.z.boolean(),
        used: zod_1.z.number().int().min(0),
        limit: zod_1.z.number().int().min(0),
        resetsAt: zod_1.z.iso.datetime(),
    }),
    assets: zod_1.z.array(exports.WalletAssetSchema),
});
exports.WalletResponseSchema = zod_1.z.object({
    provisioning: zod_1.z.object({
        status: auth_1.ProvisioningStatusSchema,
        step: zod_1.z.enum(['create_tenant', 'chain_settings', 'tenant_assets', 'done']).nullable(),
        canRetry: zod_1.z.boolean(),
    }),
    chains: zod_1.z.array(exports.WalletChainSchema),
});
//# sourceMappingURL=wallet.js.map